import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SteelCityTracking from "./Pincodefinder/SteelCityTracking";
import Starlink from "./Pincodefinder/Starlink";
import Excelimport from "./Pincodefinder/Excelimport";
import DeliveryUp from "./Pincodefinder/DeliveryUp";
import DeleteLRUpload from "./Pincodefinder/DeleteLRUpload";
import StatusEntry from "./Pincodefinder/StatusEntry";
import Dashboard from "./Dashboard/Dashboard";
import ReceivedPay from "./assets/PaymentReceived/PaymentReceived";
import CreditNote from "./assets/PaymentReceived/CreditNote";
import ReportScreen from "./assets/PaymentReceived/ReportScreen";
import ManifestForm from "./assets/PaymentReceived/ManifestForm";
import Automail from "./assets/PaymentReceived/Automail";
import InvoiceForm from "./assets/PaymentReceived/InvoiceForm";
import Paradiseinternational from "./Pincodefinder/Paradiseinternational";
import VendorRate from "./VendorRate/VendorRate";
import DabhlogisticsTracking from "./Pincodefinder/DabhlogisticsTracking";
import BdexpressTracking from "./Pincodefinder/BdexpressTracking";
import ShreeshyamTracking from "./Pincodefinder/ShreeshyamTracking";
import KandoliyaTracking from "./Pincodefinder/KandoliyaTracking";
import Shrikaraniroadlies from "./Pincodefinder/Shrikaraniroadlies";
import Flyingman from "./Pincodefinder/Flyingman";
import ZipwheelTracking from "./Pincodefinder/ZipwheelTracking";
//import SevaSpeedTracking from "./Pincodefinder/SevaSpeedTracking";
import FlypackTracking from "./Pincodefinder/FlypackTracking";
import MrpLogistics from "./Pincodefinder/MrpLogistics";
import SendMailFrontend from "./Pincodefinder/SendMailFrontend";
import DnlexpressTracking from "./Pincodefinder/DnlexpressTracking";
import SkMailingTracking from "./Pincodefinder/SkMailingTracking";
import DkCargoTracking from "./Pincodefinder/DkCargoTracking";
import TransworldTracking from "./Pincodefinder/TransworldTracking";
import A2zLogisticsTracking from "./Pincodefinder/A2zLogisticsTracking";
import RightexpressTracking from "./Pincodefinder/RightexpressTracking";
//import SubhamTracking from './Pincodefinder/SubhamTracking';
import Pincode from "./Pincodefinder/Pincode";
import CourieraddaaTracking from "./Pincodefinder/CourieraddaaTracking";
import Jvinternationalcourier from "./Pincodefinder/Jvinternationalcourier";

//import Southerncourier from "./Pincodefinder/Southerncourier";
import Shubhtracking from "./Pincodefinder/Shubhtracking";
import Atecourier from "./Pincodefinder/Atecourier";
//import SscouriersTracking from "./Pincodefinder/SscouriersTracking";
import YashCourierTracking from "./Pincodefinder/YashCourierTracking";
import LaxmicargoTracking from "./Pincodefinder/LaxmicargoTracking";
//import ShivamLogistic from "./Pincodefinder/ShivamLogistic";
//import MexpresscargoTracking from "./Pincodefinder/MexpresscargoTracking";
//import ShivgranthTracking from "./Pincodefinder/ShivgranthTracking";
//import WheelsTransTracking from "./Pincodefinder/WheelsTransTracking";
import CSAMTracking from "./Pincodefinder/CSAMTracking";
import BhairavTracking from "./Pincodefinder/BhairavTracking";
import Tracking12 from "./Pincodefinder/Tracking12";
import Tracking from "./Pincodefinder/Tracking";
import KkexpressTracking from "./Pincodefinder/KkexpressTracking";
import SpeedTracking from "./Pincodefinder/SpeedTracking";
import GeniusTracking from "./Pincodefinder/GeniusTracking";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/TrackingSteelcity" element={<SteelCityTracking />} />
        <Route path="/Starlink" element={<Starlink />} />
        <Route
          path="/Paradiseinternational"
          element={<Paradiseinternational />}
        />
        <Route path="/Excelimport" element={<Excelimport />} />
        <Route path="/DeliveryUp" element={<DeliveryUp />} />
        <Route path="/StatusEntry" element={<StatusEntry />} />
        <Route path="/Automail" element={<Automail />} />
        <Route path="/ReceivedPay" element={<ReceivedPay />} />
        <Route path="/CreditNote" element={<CreditNote />} />
        <Route path="/ReportScreen" element={<ReportScreen />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/InvoiceForm" element={<InvoiceForm />} />
        <Route path="/VendorRate" element={<VendorRate />} />
        <Route path="/ManifestForm" element={<ManifestForm />} />
        <Route path="/Flyingman" element={<Flyingman />} />
        <Route path="/BdexpressTracking" element={<BdexpressTracking />} />
        <Route path="/ShreeshyamTracking" element={<ShreeshyamTracking />} />
        <Route path="/ZipwheelTracking" element={<ZipwheelTracking />} />
        <Route path="/SpeedTracking" element={<SpeedTracking />} />
        <Route path="/Shrikaraniroadlies" element={<Shrikaraniroadlies />} />
        <Route path="/FlypackTracking" element={<FlypackTracking />} />
        <Route path="/TransworldTracking" element={<TransworldTracking />} />
        <Route path="/MrpLogistics" element={<MrpLogistics />} />
        <Route path="/SkMailingTracking" element={<SkMailingTracking />} />
        <Route path="/DnlexpressTracking" element={<DnlexpressTracking />} />
        <Route
          path="/A2zLogisticsTracking"
          element={<A2zLogisticsTracking />}
        />
        <Route path="/DkCargoTracking" element={<DkCargoTracking />} />
        <Route
          path="/RightexpressTracking"
          element={<RightexpressTracking />}
        />
        {/* <Route path="/SubhamTracking" element={<SubhamTracking/>} /> */}
        <Route path="/Pincode" element={<Pincode />} />
        <Route path="/SendMailFrontend" element={<SendMailFrontend />} />
        <Route path="/KandoliyaTracking" element={<KandoliyaTracking />} />
        <Route
          path="/DabhlogisticsTracking"
          element={<DabhlogisticsTracking />}
        />
        <Route path="/DeleteLRUpload" element={<DeleteLRUpload />} />
        <Route
          path="/CourieraddaaTracking"
          element={<CourieraddaaTracking />}
        />
        <Route
          path="/Jvinternationalcourier"
          element={<Jvinternationalcourier />}
        />
        <Route path="/KkexpressTracking" element={<KkexpressTracking />} />
        {/* <Route path="/Southerncourier" element={<Southerncourier />}/> */}

        <Route path="/Shubhtracking" element={<Shubhtracking />} />
        <Route path="/Atecourier" element={<Atecourier />} />
        {/* <Route path="/SscouriersTracking" element={<SscouriersTracking />} />  */}
        <Route path="/YashCourierTracking" element={<YashCourierTracking />} />
        <Route path="/LaxmicargoTracking" element={<LaxmicargoTracking />} />
        {/* <Route path="/ShivamLogistic" element={<ShivamLogistic />} />  */}
        {/* <Route
          path="/MexpresscargoTracking"
          element={<MexpresscargoTracking />} />  */}

        {/* <Route path="/WheelsTransTracking" element={<WheelsTransTracking />} /> */}

        <Route path="/BhairavTracking" element={<BhairavTracking />} />

        <Route path="/CSAMTracking" element={<CSAMTracking />} />

        {/* <Route path="/ShivgranthTracking" element={<ShivgranthTracking />} /> */}
        <Route path="/Tracking12" element={<Tracking12 />} />
        <Route path="/GeniusTracking" element={<GeniusTracking />} />
        <Route path="/Tracking" element={<Tracking />} />
      </Routes>
    </Router>
  );
}

export default App;
